module.exports = __webpack_public_path__ + "img/snapchat2.7aac8700.svg";